import { Component } from '@angular/core';


@Component({
    selector: 'app-overview-dashboard',
    templateUrl: './overview-dashboard.component.html',
    styleUrls: ['./overview-dashboard.component.css'],
    standalone: false
})
export class OverviewDashboardComponent {

}
